import { render, staticRenderFns } from "./TermsService.vue?vue&type=template&id=0afb5de6&scoped=true&"
import script from "./TermsService.vue?vue&type=script&lang=js&"
export * from "./TermsService.vue?vue&type=script&lang=js&"
import style0 from "./TermsService.vue?vue&type=style&index=0&id=0afb5de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb5de6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
